import {
	CerebrumxDiagnosticsTab,
	CerebrumxEnergyTab,
	CerebrumxLiveTab,
	CerebrumxLocationTab,
	CerebrumxVehicleTab,
} from './tabs';

const tab = (value, Content) => ({ value, labelKey: `oemDataModal_cerebrumx_tabs_${value}`, Content });

/** CerebrumX (OEM telematics): five tabs, each drawing only what the payload carries. */
export const cerebrumxAdapter = {
	nameKey: 'oemDataModal_cerebrumx_name',
	tabs: [
		tab('live', CerebrumxLiveTab),
		tab('energy', CerebrumxEnergyTab),
		tab('diagnostics', CerebrumxDiagnosticsTab),
		tab('location', CerebrumxLocationTab),
		tab('vehicle', CerebrumxVehicleTab),
	],
};
